export default "__VITE_ASSET__B_OBF0yu__"